import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { ChevronRight, Package } from "lucide-react";
import { Link } from "react-router-dom";
import { useAssets } from "../../assets/contexts/AssetsContext";
import { SPACING } from "../constants/spacing";
import { useTheme } from "../contexts/ThemeContext";
import { resolveImageUrl } from "../utils/imageUrl";

const SidebarAssetList = () => {
  const { assets, loading } = useAssets();
  const { colors } = useTheme();

  if (loading || !assets || assets.length === 0) {
    return null;
  }

  // Show maximum 10 assets
  const displayAssets = assets.slice(0, 10);

  return (
    <>
      <Box sx={{ pb: 2 }}>
        <Typography
          variant="h4"
          sx={{
            px: SPACING.sm,
            pt: SPACING.md,
            pb: 1.5,
            display: "block",
          }}
        >
          Assets <ChevronRight size={18} />
        </Typography>

        <List sx={{ p: 0 }}>
          {displayAssets.map((asset) => (
            <ListItem key={asset.id} disablePadding>
              <ListItemButton
                component={Link}
                to={`/assets/${asset.id}`}
                sx={{
                  borderRadius: 2,
                  mb: 0.5,
                  py: 1,
                  px: 2,
                  minHeight: 48,
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
              >
                <Avatar
                  src={resolveImageUrl(asset.thumbnail)}
                  sx={{
                    width: 32,
                    height: 32,
                    mr: 2,
                    backgroundColor: colors.secondary,
                  }}
                >
                  {!asset.thumbnail && (
                    <Package
                      size={16}
                      style={{
                        color: colors.text.secondary,
                      }}
                    />
                  )}
                </Avatar>

                <ListItemText
                  primary={asset.title}
                  primaryTypographyProps={{
                    variant: "bodySm",
                    noWrap: true,
                    sx: {
                      fontWeight: 500,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
};

export default SidebarAssetList;
